"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var StringUtils_1 = require("@twii/core/lib/StringUtils");
var ListingLinkModel = /** @class */ (function () {
    function ListingLinkModel(listing, data) {
        this.validationErrors = [];
        this._listing = listing;
        if (data) {
            this.setData(data);
        }
    }
    Object.defineProperty(ListingLinkModel.prototype, "valid", {
        get: function () {
            return this.validationErrors.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingLinkModel.prototype, "listing", {
        get: function () {
            return this._listing;
        },
        enumerable: true,
        configurable: true
    });
    ListingLinkModel.prototype.validate = function () {
        this.validationErrors = [];
        if (StringUtils_1.isBlank(this.name)) {
            this.validationErrors.push({ prop: "name", propTitle: "Name", message: "Name is required" });
        }
        if (StringUtils_1.isBlank(this.url)) {
            this.validationErrors.push({ prop: "url", propTitle: "URL", message: "URL is required" });
        }
    };
    ListingLinkModel.prototype.setName = function (name) {
        this.name = name;
    };
    ListingLinkModel.prototype.setUrl = function (url) {
        this.url = url;
    };
    ListingLinkModel.prototype.removeFromListing = function () {
        this.listing.removeLink(this);
    };
    Object.defineProperty(ListingLinkModel.prototype, "data", {
        get: function () {
            return { name: this.name, url: this.url };
        },
        set: function (value) {
            this.setData(value);
        },
        enumerable: true,
        configurable: true
    });
    ListingLinkModel.prototype.setData = function (data) {
        this.setName(data ? data.name : undefined);
        this.setUrl(data ? data.url : undefined);
    };
    __decorate([
        mobx_1.observable
    ], ListingLinkModel.prototype, "_listing", void 0);
    __decorate([
        mobx_1.observable
    ], ListingLinkModel.prototype, "validationErrors", void 0);
    __decorate([
        mobx_1.observable
    ], ListingLinkModel.prototype, "name", void 0);
    __decorate([
        mobx_1.observable
    ], ListingLinkModel.prototype, "url", void 0);
    __decorate([
        mobx_1.computed
    ], ListingLinkModel.prototype, "valid", null);
    __decorate([
        mobx_1.computed
    ], ListingLinkModel.prototype, "listing", null);
    __decorate([
        mobx_1.action
    ], ListingLinkModel.prototype, "validate", null);
    __decorate([
        mobx_1.action
    ], ListingLinkModel.prototype, "setName", null);
    __decorate([
        mobx_1.action
    ], ListingLinkModel.prototype, "setUrl", null);
    __decorate([
        mobx_1.action
    ], ListingLinkModel.prototype, "removeFromListing", null);
    __decorate([
        mobx_1.computed
    ], ListingLinkModel.prototype, "data", null);
    __decorate([
        mobx_1.action
    ], ListingLinkModel.prototype, "setData", null);
    return ListingLinkModel;
}());
exports.ListingLinkModel = ListingLinkModel;
